import * as React from 'react'

import { useProcurifyIntl } from '@webapp/hooks'
import { GlobalSearchTriggerButton } from './components/GlobalSearchTriggerButton'
import messages from './messages'
import { useGlobalSearchTrigger } from './useGlobalSearchTrigger'

export const GlobalSearchTrigger = () => {
  const intl = useProcurifyIntl()
  const { buttonRef, shortcutLabel, onClick } = useGlobalSearchTrigger()

  return (
    <GlobalSearchTriggerButton
      buttonRef={buttonRef}
      ariaLabel={intl.formatMessage(messages.searchAriaLabel, {
        shortcutLabel,
      })}
      placeholder={intl.formatMessage(messages.searchPlaceholder)}
      shortcutLabel={shortcutLabel}
      onClick={onClick}
    />
  )
}
